import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section
      data-testid="page-not-found"
      className="min-h-[70vh] flex items-center justify-center px-6"
    >
      <div className="text-center max-w-md">
        <div className="overline">404</div>
        <h1 className="mt-6 font-serif text-4xl lg:text-5xl tracking-tight text-slate-900">
          Page not found.
        </h1>
        <p className="mt-4 text-slate-500">
          The page you&apos;re looking for is not available.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="mt-8 inline-block text-[12px] tracking-[0.2em] uppercase font-semibold bg-slate-900 text-white px-6 py-3.5 hover:bg-slate-800 transition-colors"
        >
          Return home
        </Link>
      </div>
    </section>
  );
}
